import { styled } from "@mui/material/styles"
import { Avatar, Box, IconButton, Toolbar, Typography } from "@mui/material"
import MuiAppBar from "@mui/material/AppBar"
import MenuIcon from "@mui/icons-material/Menu"

import PatchNotesDialog from "@/features/patchNotes/PatchNotesDialog.jsx"
import { HelpMenu } from "@/features/tutorials"
import WetterWeltLogo from "../../assets/images/WetterWeltLogo.jsx"
import AlbisLogo from "../../assets/images/AlbisLogoFull.png"
import { drawerWidth, appBarHeight } from "@/config/layout"

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  backgroundColor: "white",
  height: appBarHeight,
}))

// Obere App-Leiste; children landen rechts vor dem Avatar (z.B. NotificationBell).
export default function AppHeader({
  openDrawer,
  onDrawerOpen,
  canSeeFleetOnline,
  userInitial,
  children,
}) {
  return (
    <AppBar position="fixed" open={openDrawer} elevation={0}>
      <Toolbar sx={{ px: 1 }} disableGutters>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={onDrawerOpen}
          edge="start"
          sx={{
            ml: 0,
            ...(openDrawer && { display: "none" }),
            color: "#004f7d",
          }}
        >
          <MenuIcon />
        </IconButton>
        <IconButton sx={{ disabled: true, ml: 1 }}>
          <WetterWeltLogo sx={{ fontSize: 50 }} />
        </IconButton>
        <Box sx={{ display: "flex", alignItems: "baseline" }}>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              display: { xs: "none", sm: "flex" },
              color: "#004f7d",
              fontWeight: "bold",
            }}
          >
            <span style={{ fontWeight: "bold" }}>METEO</span>&nbsp;
            <span style={{ fontWeight: "100" }}>TRACKER</span>
          </Typography>
          <PatchNotesDialog />
        </Box>
        <Box
          sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 0.5 }}
        >
          {canSeeFleetOnline ? (
            <IconButton
              component="a"
              href="https://fleetonline.albis-mp.com/login"
              sx={{
                border: "1px solid  #004f7d",
                borderRadius: "50px",
                py: 0.5,
                pl: 2,
                pr: 1,
              }}
            >
              <img src={AlbisLogo} style={{ height: "30px" }} />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  ml: 1,
                  height: "30px",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#004f7d", fontWeight: "100", lineHeight: 1 }}
                >
                  Switch to
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: "#004f7d",
                    fontSize: "100",
                    fontWeight: "bold",
                    lineHeight: 1,
                  }}
                >
                  Fleet Online
                </Typography>
              </Box>
            </IconButton>
          ) : null}
          <HelpMenu />
          {children}
          <IconButton aria-label="account" sx={{ color: "#004f7d" }}>
            <Avatar
              sx={{
                width: 28,
                height: 28,
                bgcolor: "#004f7d",
                color: "white",
                fontSize: 16,
                fontWeight: 700,
              }}
            >
              {userInitial || "?"}
            </Avatar>
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  )
}
